import React from 'react';
import { Link } from 'react-router-dom';
import barkarLogo from '../assets/logos/barkar.png';
import barkarStudioLogo from '../assets/logos/barkar_studio.png';
import shanahLogo from '../assets/logos/shannah_new.png';
import kamLogo from '../assets/logos/kam.png';
import riyadhiLogo from '../assets/logos/riyadhi.png';
import baderahLogo from '../assets/logos/baderah.png';

const BarkarProjectsPage: React.FC = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary to-primary-dark text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="flex justify-center mb-6">
            <img src={barkarLogo} alt="شعار بركار" className="h-24 md:h-32" />
          </div>
          <h1 className="text-4xl font-bold mb-6">مشروع بركار</h1>
          <p className="text-xl max-w-3xl mx-auto">
            كيان تقني يضم تحت مظلته عدة مشاريع وبرامج تعمل على الأتمتة والتحول الرقمي، وتخدم الأفراد والمنشآت عبر أدوات تمكينية ذكية
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">عن بركار</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              تأسس بركار كمشروع يهدف إلى تقديم حلول تقنية مبتكرة تساعد الأفراد والمنشآت على تحسين أدائهم وزيادة إنتاجيتهم من خلال أدوات ذكية وسهلة الاستخدام.
            </p>
          </div>

          {/* Barkar Projects */}
          <div className="mb-16">
            <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">مشاريع بركار</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Project 1 - Barkar Studio */}
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="h-48 bg-gray-100 flex items-center justify-center">
                  <img src={barkarStudioLogo} alt="شعار بركار استوديو" className="h-24 object-contain" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">بركار استوديو</h3>
                  <div className="flex justify-between items-center mt-4">
                    <span className="text-sm text-gray-500">متاح حالياً</span>
                    <button className="text-primary hover:text-primary-dark font-medium">اكتشف المزيد</button>
                  </div>
                </div>
              </div>

              {/* Project 2 - Shanah */}
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="h-48 bg-gray-100 flex items-center justify-center">
                  <img src={shanahLogo} alt="شعار تطبيق شنة" className="h-24 object-contain" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">تطبيق شنة</h3>
                  <div className="flex justify-between items-center mt-4">
                    <span className="text-sm text-gray-500">متاح قريباً</span>
                    <button className="text-primary hover:text-primary-dark font-medium">اكتشف المزيد</button>
                  </div>
                </div>
              </div>

              {/* Project 3 - Kam */}
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="h-48 bg-gray-100 flex items-center justify-center">
                  <img src={kamLogo} alt="شعار تطبيق كم" className="h-24 object-contain" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">تطبيق كم</h3>
                  <div className="flex justify-between items-center mt-4">
                    <span className="text-sm text-gray-500">متاح قريباً</span>
                    <button className="text-primary hover:text-primary-dark font-medium">اكتشف المزيد</button>
                  </div>
                </div>
              </div>

              {/* Project 4 - Riyadhi */}
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="h-48 bg-gray-100 flex items-center justify-center">
                  <img src={riyadhiLogo} alt="شعار منصة رياضي" className="h-24 object-contain" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">منصة رياضي</h3>
                  <div className="flex justify-between items-center mt-4">
                    <span className="text-sm text-gray-500">متاح قريباً</span>
                    <button className="text-primary hover:text-primary-dark font-medium">اكتشف المزيد</button>
                  </div>
                </div>
              </div>

              {/* Project 5 - Baderah */}
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="h-48 bg-gray-100 flex items-center justify-center">
                  <img src={baderahLogo} alt="شعار منصة بادرة" className="h-24 object-contain" />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">منصة بادرة</h3>
                  <div className="flex justify-between items-center mt-4">
                    <span className="text-sm text-gray-500">متاح قريباً</span>
                    <button className="text-primary hover:text-primary-dark font-medium">اكتشف المزيد</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Vision & Mission */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-gray-900 mb-4">رؤيتنا</h3>
              <p className="text-gray-600">
                أن نكون الشريك التقني الأول للمنشآت الصغيرة والمتوسطة في المملكة العربية السعودية، ونساهم في تمكينها من التحول الرقمي وزيادة كفاءتها التشغيلية.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-gray-900 mb-4">رسالتنا</h3>
              <p className="text-gray-600">
                تقديم حلول تقنية مبتكرة وسهلة الاستخدام تساعد المنشآت على تحسين أدائها وزيادة إنتاجيتها، وتمكنها من التركيز على نمو أعمالها.
              </p>
            </div>
          </div>

          {/* Call to Action */}
          <div className="bg-gradient-to-r from-primary to-primary-dark text-white p-8 rounded-lg">
            <div className="text-center">
              <h3 className="text-2xl font-bold mb-4">تواصل معنا</h3>
              <p className="text-lg mb-6 max-w-2xl mx-auto">
                للمزيد من المعلومات حول مشاريع بركار وكيف يمكننا مساعدتك، لا تتردد في التواصل معنا.
              </p>
              <Link to="/contact" className="inline-block bg-white text-primary hover:bg-gray-100 px-6 py-3 rounded-md font-medium transition duration-300">
                تواصل معنا
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BarkarProjectsPage;
